import { render, staticRenderFns } from "./phoneBooks_img.vue?vue&type=template&id=3915a99e&scoped=true&"
import script from "./phoneBooks_img.vue?vue&type=script&lang=js&"
export * from "./phoneBooks_img.vue?vue&type=script&lang=js&"
import style0 from "./phoneBooks_img.vue?vue&type=style&index=0&id=3915a99e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3915a99e",
  null
  
)

export default component.exports